var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bg-image"}},[_c('registration-success-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }